import { AnyObject } from 'yup';

export const filterObjByKeys = (obj: AnyObject, allowedKeys: string[]) => {
  const filtered = Object.keys(obj)
    .filter((key) => allowedKeys.includes(key))
    .reduce((acc: AnyObject, key) => {
      acc[key] = obj[key];
      return acc;
    }, {});

  return filtered;
};
